<template>
    <div class="bg-purple-600">
        <div class="mx-auto max-w-7xl py-10 lg:py-16 px-6 text-center lg:px-8">
            <div class="mx-auto max-w-6xl">
                <div class="flex gap-x-5 justify-center items-center">
                    <NuxtImg src="/images/games/icons/anime-defenders.webp" class="h-10 rounded-md" />
                    <div>
                        <h1 class="text-xl lg:text-3xl text-white font-bold">Anime Defenders</h1>
                    </div>
                </div>
            </div>
            <p class="mt-3.5 mx-auto max-w-6xl font-medium lg:text-lg leading-6 lg:leading-8 text-white/60">Hood Modded is a Roblox game offering an enhanced urban experience where players engage in criminal or policing activities. It features custom weapons, unique items, and advanced gameplay mechanics, focusing on role-playing and player interactions in a gritty city environment.</p>
            <div class="mt-8 max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 justify-center">
                <NuxtLink href="/da-hood">
                    <NuxtImg class="rounded-md" src="https://cdn.discordapp.com/attachments/1246564302316507318/1271210069639565352/Rockets.png?ex=66b68222&is=66b530a2&hm=fdb9cc99645b5521b0406bef9b298067cdc00996137b8964d2007689ff368ace&" />
                </NuxtLink>
                <NuxtLink href="/adopt-me">
                    <NuxtImg class="rounded-md" src="https://cdn.discordapp.com/attachments/1246564302316507318/1271212414771138712/Rockets.png?ex=66b68451&is=66b532d1&hm=0a3304fb88aaa19c6774c5e59d51259dff2f034f5f2ce01fe631975a8ceeb611&" />
                </NuxtLink>
                <NuxtLink href="/mm2">
                    <NuxtImg class="rounded-md" src="https://cdn.discordapp.com/attachments/1246564302316507318/1271190218132689118/Rockets.png?ex=66b66fa5&is=66b51e25&hm=32a0a6ff925f2bc388fdd349d6eaea7e997d1e0201b3fe4d5a14282eb7c97c70&" />
                </NuxtLink>
                <NuxtLink href="/psx">
                    <NuxtImg class="rounded-md" src="https://cdn.discordapp.com/attachments/1246564302316507318/1271190049316143184/Rockets.png?ex=66b66f7d&is=66b51dfd&hm=c79eacda6fd0a8fe803ead53c371f086ad7bd7052cc76ba37a1b9fdcb8cd3ae9&" />
                </NuxtLink>
                <NuxtLink href="/psx">
                    <NuxtImg class="rounded-md" src="https://cdn.discordapp.com/attachments/1246564302316507318/1271189935944372284/Rockets.png?ex=66b66f62&is=66b51de2&hm=086cb77874d31e432cf96d6d03518de8e6741a1d8433765072b64aa85a7d0eb2&" />
                </NuxtLink>
            </div>
        </div>
    </div>
    <NuxtLayout name="ads">
        sss
    </NuxtLayout>
</template>

<script setup lang="ts">

</script>